import { createFileRoute, Link } from "@tanstack/react-router";

import { Container } from "@roqua/components";
import { Section, SectionHeader } from "@roqua/components/sections";
import { Button } from "@roqua/components/ui/button";

import { PageTitle } from "@/components/PageTitle";

export const Route = createFileRoute("/$organizationKey/$dossierId/design/")({
  component: RouteComponent,
});

function RouteComponent() {
  const params = Route.useParams();

  return (
    <>
      <PageTitle title="designSystem" />
      <Section variant="header">
        <SectionHeader header="Header" />
      </Section>

      <Section>
        <Container>
          <Button asChild variant="link">
            <Link to="/$organizationKey/$dossierId/design/components" params={params}>
              Components
            </Link>
          </Button>
          <Button asChild variant="link">
            <Link to="/$organizationKey/$dossierId/design/forms" params={params}>
              Forms
            </Link>
          </Button>
          <Button asChild variant="link">
            <Link to="/$organizationKey/$dossierId/design/colors" params={params}>
              Colors
            </Link>
          </Button>
        </Container>
      </Section>
    </>
  );
}
